module.exports = __webpack_public_path__ + "static/media/dynamicResults2.dc8787e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dynamicResults2.png
// module id = 166
// module chunks = 0